import {
    openAccordionItem,
    closeAccordionItem,
    openAccordionItemExclusive
} from './third-party/accordion.js';

const ACCORDION_SELECTOR = '.atb-checkout-accordion';

// Build a map: { "booking-details": element, ... }
const stageMap = {};
document.querySelectorAll('.atb-checkout-accordion-item')
  .forEach((el, index) => stageMap[el.dataset.stageId] = { element: el, index });

/** 
 * Roll back to a specific stage in the checkout process
 * Used on the "Edit" buttons in the checkout stage accordion headers.
 * 
 * @param {string} targetId - The ID of the checkout stage to return to. 
 * @returns {void}
*/
const returnToStageUI = (targetStageId) => {    
    if (!stageMap[targetStageId]) {
        console.warn('Stage ID', targetStageId, 'not in stage config');
        return;
    }

    updateMobileProgressBar(targetStageId);

    const allStages = Object.values(stageMap);
    const targetIndex = stageMap[targetStageId].index;

    // Walk backwards until target stage is reached
    for (let i = allStages.length - 1; i >= 0; i--) {
        const stage = allStages[i].element;

        // Reset completion state
        stage.classList.remove('complete');

        // Disable accordion buttons by default
        stage.querySelectorAll('.accordion-button')
            .forEach(btn => btn.disabled = true);

        // Stop once we reach the target stage
        if (stage.dataset.stageId === targetStageId) {
            break;
        }
    }

    // Open the target accordion item exclusively
    openAccordionItemExclusive(ACCORDION_SELECTOR, targetIndex);
}

/**
 * Given the IDs of the current and next stages, closes the current stage accordion item and opens the next stage item
 * @param {*} currentStageId 
 * @param {*} nextStageId 
 */
const showNextStageUI = (currentStageId, nextStageId) => {
    window.scrollTo({ top: 0, behavior: "smooth" });

    const currentItem = document.querySelector(
        `.atb-checkout-accordion-item[data-stage-id="${currentStageId}"]`
    );

    const nextItem = document.querySelector(
        `.atb-checkout-accordion-item[data-stage-id="${nextStageId}"]`
    );

    if (!currentItem || !nextItem) return;

    markCompletedStagesThrough(currentStageId, nextStageId);

    // Close/Open the correct accordions
    closeAccordionItem(ACCORDION_SELECTOR, stageMap[currentStageId].index);
    openAccordionItem(ACCORDION_SELECTOR, stageMap[nextStageId].index);
}

function markCompletedStagesThrough(currentStageId, nextStageId) {
    const currentIndex = stageMap[currentStageId].index;
    const nextIndex = stageMap[nextStageId].index;
    const stages = Object.values(stageMap);

    for (let index = currentIndex; index < nextIndex; index++) {
        const stage = stages[index].element;
        stage.classList.add('complete');

        const headerBtn = stage.querySelector('.accordion-button');
        if (headerBtn)
            headerBtn.disabled = false;
    }
}

const setStageComplete = (targetId) => {
    const checkoutStageItem = document.querySelector(`#atb-checkout-accordion-item-${targetId}`);

    // TODO: May need to check if element has class?
    checkoutStageItem.classList.add('complete');
}


export {
    setStageComplete,
    showNextStageUI,
    returnToStageUI
}
